import { IsNotEmpty, IsString, IsOptional, IsUUID, MaxLength, IsBoolean } from 'class-validator';

export class CreateConfirmatoryTestingScheduleRequestDto {
    /**
     * Reference to product in MPD
     * @example 'a1b2c3d4-e5f6-7890-1234-567890abcdef'
     */
    @IsNotEmpty()
    @IsUUID()
    productId: string;

    /**
     * Product number
     * @example '100487'
     */
    @IsNotEmpty()
    @IsString()
    @MaxLength(100)
    productNumber: string;

    /**
     * Product brand and name
     * @example 'Zepzelca Lurbinectedin for injection, 4mg per vial'
     */
    @IsNotEmpty()
    @IsString()
    @MaxLength(500)
    productBrandName: string;

    /**
     * Drug Identification Number
     * @example '02520834'
     */
    @IsOptional()
    @IsString()
    @MaxLength(50)
    din?: string;

    /**
     * Natural Product Number
     * @example '80025550'
     */
    @IsOptional()
    @IsString()
    @MaxLength(50)
    npn?: string;

    /**
     * Fabricator information (optional)
     * @example 'Baxter Oncology, Germany'
     */
    @IsOptional()
    @IsString()
    @MaxLength(500)
    fabricator?: string;

    /**
     * Product size (optional)
     * @example '30ml vial'
     */
    @IsOptional()
    @IsString()
    @MaxLength(100)
    size?: string;

    /**
     * Dosage form (optional)
     * @example 'Powder (Sterile) For IV injection, by infusion.'
     */
    @IsOptional()
    @IsString()
    @MaxLength(500)
    dosageForm?: string;

    /**
     * Quantity for full test (optional)
     * @example '60 vials'
     */
    @IsOptional()
    @IsString()
    @MaxLength(100)
    qtyForFullTest?: string;

    /**
     * Whether this schedule is active
     * If false, product doesn't require annual confirmatory testing
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    isActive?: boolean;

    /**
     * Reason for disabling the schedule (if isActive is false)
     * @example 'Product exempt from annual testing per regulatory guidance'
     */
    @IsOptional()
    @IsString()
    @MaxLength(500)
    disabledReason?: string;
}

